interface TermSection {
  title: string;
  items: string[];
}

export const termsTitle = "Termos de Envio de Arquivos";

export const uploadTerms: TermSection[] = [
  {
    title: "1. Responsabilidade pelo Conteúdo",
    items: [
      "O usuário é inteiramente responsável pelo conteúdo dos arquivos enviados.",
      "Os arquivos devem ser modelos 3D originais ou com direitos de uso."
    ]
  },
  {
    title: "2. Formato e Qualidade",
    items: [
      "Apenas arquivos no formato STL são aceitos.",
      "O arquivo deve estar em boas condições para impressão.",
      "Tamanho máximo por arquivo: 50MB."
    ]
  },
  {
    title: "3. Privacidade e Segurança",
    items: [
      "Seus arquivos serão tratados com confidencialidade.",
      "Não compartilharemos seus modelos com terceiros."
    ]
  },
  {
    title: "4. Processo de Impressão",
    items: [
      "A qualidade final depende da qualidade do arquivo enviado.",
      "Podem haver pequenas variações entre o modelo digital e o impresso."
    ]
  },
  {
    title: "5. Orçamento e Produção",
    items: [
      "O orçamento será baseado no volume e complexidade do modelo.",
      "O prazo de produção será informado após análise do arquivo."
    ]
  }
]; 